import { useTranslation } from "react-i18next";
import {
  ASSET_CONDITION_LABEL,
  ASSET_USAGE_LABEL,
  type AssetCondition,
  type AssetUsage,
} from "../api/assets";

type Translate = (key: string, fallback: string) => string;

/** Contract §7: ISPRAVAN green, NEISPRAVAN red, NA_SERVISU amber, OTPISAN grey. */
const CONDITION_CLASS: Record<AssetCondition, string> = {
  ISPRAVAN: "tag ok dot",
  NEISPRAVAN: "tag err dot",
  NA_SERVISU: "tag warn dot",
  OTPISAN: "tag neutral dot",
};

export function conditionLabel(t: Translate, condition: AssetCondition): string {
  return t(`assets.condition.${condition}`, ASSET_CONDITION_LABEL[condition] ?? condition);
}

export function usageLabel(t: Translate, usage: AssetUsage): string {
  return t(`assets.usage.${usage}`, ASSET_USAGE_LABEL[usage] ?? usage);
}

/** Coloured `.tag` chip for an asset condition (stanje). */
export function ConditionChip({ condition, className }: { condition: AssetCondition; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={`${CONDITION_CLASS[condition] ?? "tag dot"}${className ? ` ${className}` : ""}`} data-condition={condition}>
      {conditionLabel(t, condition)}
    </span>
  );
}

/** Neutral chip for usage (upotreba): MONTIRAN (info) / NA_LAGERU (grey). */
export function UsageChip({ usage, className }: { usage: AssetUsage; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={`tag${usage === "MONTIRAN" ? " info" : ""}${className ? ` ${className}` : ""}`} data-usage={usage}>
      {usageLabel(t, usage)}
    </span>
  );
}
